const FailureOrigin = {
    Unknown: 0,
    FieldRange: 1,
    FieldMaxLenght: 2,
    RequiredField: 3,
    InvalidObjectData: 4,
    ObjectAlreadyExists: 5,
    DecimalException: 6,
    OcrError: 7,
    ObjectUnauthorized: 8,
    DocIntelligenceProviderError: 9,
    DocIntelligenceProviderConflictsException: 10,
    InvalidFieldListConfiguration: 11,
    ContentTypeNotRecognized: 12,
    MissingDocECMAutoImportConfig: 13,
    MissingListFieldPerformanceQuery: 14,
};

export default FailureOrigin;
